import { render, staticRenderFns } from "./chart-of-account.vue?vue&type=template&id=0e063196&scoped=true&"
import script from "./chart-of-account.vue?vue&type=script&lang=js&"
export * from "./chart-of-account.vue?vue&type=script&lang=js&"
import style0 from "./chart-of-account.vue?vue&type=style&index=0&lang=css&"
import style1 from "./chart-of-account.vue?vue&type=style&index=1&id=0e063196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e063196",
  null
  
)

export default component.exports